import React from 'react';

const CaddieSelectionList = ({ caddies = [], selectedCaddieId, onSelectCaddie }) => {
  const [expanded, setExpanded] = React.useState(new Set());

  const toggleExpand = (e, id) => {
    e.stopPropagation();
    setExpanded(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });
  };

  return (
    <div>
      <label className="onsite-form-field__label">Caddies Present</label>
      <p style={{ fontSize: '11px', color: '#8a7d6a', margin: '2px 0 10px', fontFamily: '"Poppins", sans-serif' }}>
        Select the caddie who is present today
      </p>
      {caddies.length === 0 ? (
        <p style={{ fontSize: '13px', color: '#8a7d6a', fontFamily: '"Poppins", sans-serif', margin: '8px 0 0' }}>
          No caddies registered for this participant.
        </p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {caddies.map(c => {
            const isSelected = selectedCaddieId === c._id;
            const isExpanded = expanded.has(c._id);
            return (
              <div
                key={c._id}
                style={{
                  borderRadius: '10px',
                  border: `2px solid ${isSelected ? '#a67c2c' : 'rgba(92,69,24,0.15)'}`,
                  background: isSelected ? 'rgba(166,124,44,0.08)' : '#fffef9',
                  transition: 'border-color 0.15s, background 0.15s',
                  overflow: 'hidden',
                  fontFamily: '"Poppins", sans-serif',
                }}
              >
                {/* Row */}
                <div
                  onClick={() => onSelectCaddie?.(c._id)}
                  style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 16px', cursor: 'pointer' }}
                >
                  <div style={{
                    width: '20px', height: '20px', borderRadius: '50%', flexShrink: 0,
                    border: `2px solid ${isSelected ? '#a67c2c' : 'rgba(92,69,24,0.3)'}`,
                    background: 'transparent',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    transition: 'all 0.15s',
                  }}>
                    {isSelected && <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#a67c2c' }} />}
                  </div>
                  <span style={{ fontSize: '14px', fontWeight: 500, color: '#1e1a14', flex: 1 }}>
                    {`${c.name} ${c.lname}`}
                  </span>
                  {isSelected && (
                    <span style={{
                      fontSize: '11px', fontWeight: 700, color: '#a67c2c',
                      background: 'rgba(166,124,44,0.12)', borderRadius: '20px',
                      padding: '2px 10px', letterSpacing: '0.04em',
                    }}>
                      PRESENT
                    </span>
                  )}
                  <button
                    type="button"
                    onClick={(e) => toggleExpand(e, c._id)}
                    style={{
                      background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px',
                      color: '#a67c2c', fontSize: '13px', lineHeight: 1, flexShrink: 0,
                      transition: 'transform 0.2s',
                      transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                    }}
                  >
                    <i className="fa-solid fa-chevron-down" />
                  </button>
                </div>

                {/* Expanded details */}
                {isExpanded && (
                  <div style={{
                    borderTop: '1px solid rgba(92,69,24,0.1)',
                    padding: '12px 16px 14px',
                    display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px',
                    background: 'rgba(92,69,24,0.03)',
                  }}>
                    {[
                      { label: 'First Name', value: c.name  },
                      { label: 'Last Name',  value: c.lname },
                      { label: 'Email',      value: c.email },
                    ].map(({ label, value }) => (
                      <div key={label}>
                        <div style={{ fontSize: '10px', fontWeight: 800, color: '#8a7d6a', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '3px' }}>{label}</div>
                        <div style={{ fontSize: '13px', fontWeight: 500, color: '#2a2418' }}>{value}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CaddieSelectionList;
